import type {HTMLAttributes, ReactNode} from "react";

export type DsCardProps = HTMLAttributes<HTMLDivElement> & {
  title?: string;
  children: ReactNode;
};

export function DsCard({title, className, children, ...props}: DsCardProps) {
  const cls = ["cc-ds-card", className || ""].filter(Boolean).join(" ");
  return (
    <div className={cls} {...props}>
      <div className="cc-ds-card__body">
        {title ? <h3 className="cc-ds-card__title">{title}</h3> : null}
        {children}
      </div>
    </div>
  );
}
